import { scrollToId } from "../../common/scrollHelpers.js";
import { getScrollTop } from "../../common/scrollHelpers.js";

export default () => {
  document.querySelectorAll(".js-back-to-top").forEach(el => {
    if (!document.querySelector(".theme-vu") && !document.querySelector(".theme-stewart") && !document.querySelector(".theme-stewartmarketing")) return;
    const main = document.querySelector("#main-content");

    if (!main) {
      return;
    }

    el.addEventListener("click", e => {
      e.preventDefault();
      scrollToId("#main-content");
    });

    window.addEventListener("scroll", e => {
      const scrollPosition = getScrollTop();

      // if user scrolls is able to scroll on viewport, show button
      if (scrollPosition >= window.innerHeight) {
        el.classList.add("is-active");
      } else {
        el.classList.remove("is-active");
      }
    });
  });
};
